import React, { useCallback } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { useDrag } from 'react-dnd'

import { Tag } from '../tag'
import styles from './tag-drag-area.module.css'

const propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    sourceAreaId: PropTypes.string,
    tagClassName: PropTypes.string
}

const TagDragItem = ({ item, onClick, onDelete, sourceAreaId, tagClassName }) => {
    const [, drag] = useDrag({
        item: { draggedItem: item, sourceAreaId: sourceAreaId, type: 'TAG' },
        type: 'TAG'
    })

    const onClose = useCallback(() => {
        return onDelete
            ? event => {
                  event.preventDefault()
                  event.stopPropagation()
                  onDelete(item)
              }
            : null
    }, [item, onDelete])

    const onClickTag = useCallback(
        function () {
            onClick(item)
        },
        [item, onClick]
    )

    return (
        <div ref={drag} className={styles['tag-wrapper']}>
            <Tag
                className={cx(styles['tag'], `t3sel-tag-drag-${sourceAreaId}`, tagClassName)}
                onClick={onClickTag}
                onClose={onClose()}
            >
                {item.title}
            </Tag>
        </div>
    )
}

TagDragItem.propTypes = propTypes

export { TagDragItem }
